import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-entite-search-item-convention-card',
  templateUrl: './entite-search-item-convention-card.component.html',
  styleUrls: ['./entite-search-item-convention-card.component.scss']
})
export class EntiteSearchItemConventionCardComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
